import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/login.jpg'
import _imports_1 from '@/assets/images/logo.svg'
import _imports_2 from '@/assets/images/white-logo.svg'
import _imports_3 from '@/assets/images/google.svg'
import _imports_4 from '@/assets/images/facebook2.svg'
import _imports_5 from '@/assets/images/apple.svg'


const _hoisted_1 = { class: "m-auto m-1230" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "mw-480 ms-lg-auto" }
const _hoisted_5 = { class: "form-group mb-4" }
const _hoisted_6 = { class: "form-group mb-4" }
const _hoisted_7 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-lg-6 d-none d-lg-block" }, [
        _createElementVNode("img", {
          src: _imports_0,
          class: "rounded-3",
          alt: "login"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"d-inline-block mb-4\"><img src=\"" + _imports_1 + "\" class=\"rounded-3 for-light-logo\" alt=\"login\"><img src=\"" + _imports_2 + "\" class=\"rounded-3 for-dark-logo\" alt=\"login\"></div><h3 class=\"fs-28 mb-2\">Welcome back to Trezo!</h3><p class=\"fw-medium fs-16 mb-4\"> Sign In with social account or enter your details </p><div class=\"row justify-content-center\"><div class=\"col-lg-4 col-sm-4\"><a href=\"https://www.google.com/\" target=\"_blank\" class=\"btn btn-outline-secondary bg-transparent w-100 py-2 hover-bg mb-4\" style=\"border-color:#d6dae1;\"><img src=\"" + _imports_3 + "\" alt=\"google\"></a></div><div class=\"col-lg-4 col-sm-4\"><a href=\"https://www.facebook.com/\" target=\"_blank\" class=\"btn btn-outline-secondary bg-transparent w-100 py-2 hover-bg mb-4\" style=\"border-color:#d6dae1;\"><img src=\"" + _imports_4 + "\" alt=\"facebook2\"></a></div><div class=\"col-lg-4 col-sm-4\"><a href=\"https://www.apple.com/\" target=\"_blank\" class=\"btn btn-outline-secondary bg-transparent w-100 py-2 hover-bg mb-4\" style=\"border-color:#d6dae1;\"><img src=\"" + _imports_5 + "\" alt=\"apple\"></a></div></div>", 4)),
          _createElementVNode("form", null, [
            _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"form-group mb-4\"><label class=\"label text-secondary\">Email Address</label><input type=\"email\" class=\"form-control h-55\" placeholder=\"example@trezo.com\"></div><div class=\"form-group mb-4\"><label class=\"label text-secondary\">Password</label><input type=\"password\" class=\"form-control h-55\" placeholder=\"Type password\"></div>", 2)),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_RouterLink, {
                to: "/authentication/forget-password",
                class: "text-decoration-none text-primary fw-semibold"
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode(" Forgot Password? ")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_RouterLink, {
                to: "/dashboard",
                class: "btn btn-primary fw-medium py-2 px-3 w-100"
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createElementVNode("div", { class: "d-flex align-items-center justify-content-center py-1" }, [
                    _createElementVNode("i", { class: "material-symbols-outlined text-white fs-20 me-2" }, " login "),
                    _createElementVNode("span", null, "Login")
                  ], -1)
                ])),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", null, [
                _cache[3] || (_cache[3] = _createTextVNode(" Don’t have an account. ")),
                _createVNode(_component_RouterLink, {
                  to: "/authentication/register",
                  class: "fw-medium text-primary text-decoration-none"
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode(" Register ")
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}